import { slk } from "survey-core";

slk(
    "NzM1YzBlZGMtMmNmMC00MGQ3LTlmYmYtZDM0NDBkYTZlNDdlOzE9MjAyNi0xMi0zMA=="
);